import React from 'react';
import { StyledFileList } from './styled';
import { FileListItem } from '../file-list-item';
export const FilesList = ({ files, maxSize, ...props }) => {
    return (React.createElement(StyledFileList, { role: "list" }, files.map((file) => (React.createElement(FileListItem, { key: file.uid, file: file, maxSize: maxSize, ...props })))));
};
